/**
 * The readable message inside an error thrown by an API client whose
 * `request<T>()` throws the raw response text (for example `proceduresApi`).
 *
 * Nest error bodies are JSON (`{"message": "...", "statusCode": 400}`), so the
 * banner would otherwise show a JSON blob. `apiErrorMessage` is the twin for
 * clients that throw a typed `ApiError`.
 */
export function requestErrorMessage(e: unknown, fallback: string): string {
  if (!(e instanceof Error) || !e.message) return fallback
  try {
    const parsed = JSON.parse(e.message) as { message?: string | string[] }
    if (Array.isArray(parsed.message)) return parsed.message.join('; ')
    if (typeof parsed.message === 'string') return parsed.message
  } catch {
    // not a JSON body: use the text as-is
  }
  return e.message
}
